<template>
  <div
    :class="$style.root"
    v-if="nextPageUrl"
  >
    <nuxtLink
      :class="$style.link"
      :to="nextPageUrl"
    >
      {{ $t('shared.next') }}
    </nuxtLink>
  </div>
</template>

<script setup>
const route = useRoute()
const localePath = useLocalePath()

const currentSlug = computed(() => {
  const slug = route?.params?.secondaryslug || route?.params?.slug
  return slug
})

const nextPageUrl = ref(null)
const getNextLink = () => {
  const links = Array?.from(document.querySelectorAll('[data-modal-link]'))?.filter(link => link.getAttribute('href'))
  const currentLink = links?.find(link => link.getAttribute('href')?.endsWith(currentSlug.value))
  const indexOfCurrentLink = links?.indexOf(currentLink)
  const nextLink = links?.[indexOfCurrentLink + 1]
  if (nextLink) {
    return nextLink?.getAttribute('href')
  } else if (links?.[0]) {
    return links?.[0]?.getAttribute('href')
  } else {
    return null
  }
}

watch(currentSlug, (newSlug) => {
  nextPageUrl.value = getNextLink()
}, { immediate: true })
</script>

<style module>
.root {
  composes: font-size-small from global;
  display: flex;
  justify-content: flex-end;
  margin-top: var(--unit--vertical--tripple);
}

.link {
  composes: reset-link from global;
  text-decoration-line: underline;
}

.link:hover {
  text-decoration-line: none;
}
</style>
